import axios, { AxiosResponse } from "axios";
import { ApiResult, AxiosErr } from "../Contracts/IMdels";
import { BaseModel } from "./BaseModel";

export class SenfModel extends BaseModel {
  RouteName = "Senf";
  protected AuthState: boolean = true;
  public async GetSearch(data: any) {
    try {
      return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}/${data}`, data);
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }
      throw error.response?.data.message;
    }
  }
}
